import Header from './components/Header';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <img src="/hungry_fonz_logo.png"></img>
        <p>Welcome to the best cooking website! Explore recipes and more.</p>
      </main>
    </div>
  );
}

export default App;
